import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import ClueGlyph from './ClueGlyph';
import { fetchPreview } from '../../services/wordInfoService';

const CARD_WIDTH = 300;

// Hover card for a crossword answer: Asiasanasto meaning plus the clues it had in
// earlier Norppa puzzles. Anchored to `rect`, flips above near the bottom.
const WordPeek = ({ answer, rect, pastClues = [] }) => {
  const [preview, setPreview] = useState(undefined);

  useEffect(() => {
    let live = true;
    setPreview(undefined);
    fetchPreview(answer).then(p => live && setPreview(p));
    return () => { live = false; };
  }, [answer]);

  const glosses = preview && !preview.error ? (preview.glossesFi || preview.glossesEn) : null;
  const past = [...new Set(pastClues.map(p => p.clue))].slice(0, 4);

  // Nothing to say (yet): no card rather than an empty or apologetic one.
  if (!glosses && !preview?.synonyms && !past.length) return null;

  const below = rect.bottom + 200 < window.innerHeight;
  const style = {
    left: Math.max(8, Math.min(rect.left, window.innerWidth - CARD_WIDTH - 8)),
    width: CARD_WIDTH,
    ...(below ? { top: rect.bottom + 6 } : { bottom: window.innerHeight - rect.top + 6 }),
  };

  return ReactDOM.createPortal(
    <div className="word-peek" style={style} role="tooltip">
      {glosses ? <ol>{glosses.slice(0, 3).map(g => <li key={g}>{g}</li>)}</ol>
        : preview?.synonyms ? <p>{preview.synonyms.join(', ')}</p>
        : null}
      {past.length > 0 && (
        <div className="word-peek-past">
          {past.map(clue => <div key={clue}><ClueGlyph clue={clue} /></div>)}
        </div>
      )}
    </div>,
    document.body
  );
};

export default WordPeek;
